module.exports = __webpack_public_path__ + "img/28-7.d02a61e9.jpg";